module.exports = "<div >\r\n    <div class='row'>\r\n        <!--<div class='col-sm-3'>\r\n            <nav-menu></nav-menu>\r\n        </div>-->\r\n        <div class='col-sm-12 '>\r\n            <router-outlet></router-outlet>\r\n        </div>\r\n    </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/app/app.component.html
// module id = 19
// module chunks = 0